const XLS = () => {
	return (
		<svg
			width='40'
			height='40'
			viewBox='0 0 40 40'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M24.865 19.0885L9.75391 16.4219V36.1259C9.75391 37.0257 10.4834 37.7552 11.3832 37.7552H37.4579C38.3578 37.7552 39.0872 37.0257 39.0872 36.1259V28.8663L24.865 19.0885Z'
				fill='#185C37'
			/>
			<path
				d='M24.865 2.2002H11.3832C10.4834 2.2002 9.75391 2.92967 9.75391 3.82952V11.0891L24.865 19.978L32.865 22.6446L39.0872 19.978V11.0891L24.865 2.2002Z'
				fill='#21A366'
			/>
			<path
				d='M9.75391 11.0889H24.865V19.9778H9.75391V11.0889Z'
				fill='#107C41'
			/>
			<path
				opacity='0.1'
				d='M20.569 9.31152H9.75391V31.5337H20.569C21.4677 31.5308 22.1954 30.8031 22.1984 29.9044V10.9409C22.1954 10.0422 21.4677 9.31444 20.569 9.31152Z'
				fill='black'
			/>
			<path
				opacity='0.2'
				d='M19.6801 10.2002H9.75391V32.4224H19.6801C20.5788 32.4195 21.3065 31.6917 21.3095 30.7931V11.8295C21.3065 10.9309 20.5788 10.2031 19.6801 10.2002Z'
				fill='black'
			/>
			<path
				opacity='0.2'
				d='M19.6801 10.2002H9.75391V30.6446H19.6801C20.5788 30.6417 21.3065 29.9139 21.3095 29.0153V11.8295C21.3065 10.9309 20.5788 10.2031 19.6801 10.2002Z'
				fill='black'
			/>
			<path
				opacity='0.2'
				d='M18.7912 10.2002H9.75391V30.6446H18.7912C19.6899 30.6417 20.4177 29.9139 20.4206 29.0153V11.8295C20.4177 10.9309 19.6899 10.2031 18.7912 10.2002Z'
				fill='black'
			/>
			<path
				d='M2.49652 10.2002H18.7934C19.6933 10.2002 20.4227 10.9297 20.4227 11.8295V28.1264C20.4227 29.0263 19.6933 29.7557 18.7934 29.7557H2.49652C1.59666 29.7558 0.867188 29.0263 0.867188 28.1264V11.8295C0.867188 10.9297 1.59666 10.2002 2.49652 10.2002Z'
				fill='url(#paint0_linear_16451_23114)'
			/>
			<path
				d='M5.91406 25.2736L9.34162 19.9624L6.20118 14.6807H8.72739L10.4412 18.0584C10.5994 18.3793 10.7078 18.6175 10.7665 18.7749H10.7887C10.8995 18.5227 11.0181 18.274 11.1443 18.0291L12.9763 14.6825H15.2954L12.0749 19.9331L15.3772 25.2735H12.9096L10.9301 21.566C10.8368 21.4083 10.7577 21.2426 10.6936 21.0709H10.6643C10.6063 21.2391 10.5294 21.4001 10.435 21.5509L8.39674 25.2736H5.91406Z'
				fill='white'
			/>
			<path
				d='M37.4601 2.2002H24.8672V11.0891H39.0894V3.82952C39.0894 2.92967 38.3599 2.2002 37.4601 2.2002Z'
				fill='#33C481'
			/>
			<path
				d='M24.8672 19.9775H39.0894V28.8664H24.8672V19.9775Z'
				fill='#107C41'
			/>
			<defs>
				<linearGradient
					id='paint0_linear_16451_23114'
					x1='4.26438'
					y1='8.92707'
					x2='17.0256'
					y2='31.0289'
					gradientUnits='userSpaceOnUse'
				>
					<stop stop-color='#18884F' />
					<stop offset='0.5' stop-color='#117E43' />
					<stop offset='1' stop-color='#0B6631' />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default XLS;
